import * as React from "react"

import defaults from "./dafaults"
// styles
import "../styles/css/styles.css"


const Menu = () => {

    // const [ menu, setMenu ] = React.useState(
    //     [
    //         {
    //           id: 2415,
    //           order: 1,
    //           parent: 0,
    //           title: "Wega",
    //           url: "/page/wega",
    //           attr: "Wega",
    //           target: "",
    //           classes: "",
    //           xfn: "",
    //           description: "",
    //           object_id: 291,
    //           object: "page",
    //           object_slug: "wega",
    //           type: "post_type",
    //           type_label: "Página",
    //           children: [
    //             {
    //               id: 51096,
    //               order: 2,
    //               parent: 2415,
    //               title: "Quem Somos",
    //               url: "/page/quem-somos/",
    //               attr: "",
    //               target: "",
    //               classes: "",
    //               xfn: "",
    //               description: "",
    //               object_id: 51091,
    //               object: "page",
    //               object_slug: "quem-somos",
    //               type: "post_type",
    //               type_label: "Página",
    //             },
    //             {
    //               id: 51225,
    //               order: 3,
    //               parent: 2415,
    //               title: "Patrocínios",
    //               url: "/page/patrocinios/",
    //               attr: "",
    //               target: "",
    //               classes: "",
    //               xfn: "",
    //               description: "",
    //               object_id: 51212,
    //               object: "page",
    //               object_slug: "patrocinios",
    //               type: "post_type",
    //               type_label: "Página",
    //             },
    //           ],
    //         },
    //         {
    //           id: 4011,
    //           order: 4,
    //           parent: 0,
    //           title: "Produtos",
    //           url: "/page/produtos/",
    //           attr: "",
    //           target: "",
    //           classes: "",
    //           xfn: "",
    //           description: "",
    //           object_id: 3939,
    //           object: "page",
    //           object_slug: "produtos",
    //           type: "post_type",
    //           type_label: "Página",
    //           children: [
    //             {
    //               id: 298104,
    //               order: 5,
    //               parent: 4011,
    //               title: "Filtro de Ar",
    //               url: "/produtos/filtro-de-ar/",
    //               attr: "",
    //               target: "",
    //               classes: "",
    //               xfn: "",
    //               description: "",
    //               object_id: 297348,
    //               object: "page",
    //               object_slug: "filtro-de-ar",
    //               type: "post_type",
    //               type_label: "Página",
    //             },
    //             {
    //               id: 4018,
    //               order: 6,
    //               parent: 4011,
    //               title: "Filtro de Óleo",
    //               url: "/produtos/filtro-de-oleo/",
    //               attr: "",
    //               target: "",
    //               classes: "",
    //               xfn: "",
    //               description: "",
    //               object_id: 3945,
    //               object: "page",
    //               object_slug: "filtro-de-oleo",
    //               type: "post_type",
    //               type_label: "Página",
    //             },
    //             {
    //               id: 298788,
    //               order: 7,
    //               parent: 4011,
    //               title: "Filtro do Combustível",
    //               url: "/produtos/filtro-do-combustivel/",
    //               attr: "",
    //               target: "",
    //               classes: "",
    //               xfn: "",
    //               description: "",
    //               object_id: 298781,
    //               object: "page",
    //               object_slug: "filtro-do-combustivel",
    //               type: "post_type",
    //               type_label: "Página",
    //             },
    //             {
    //               id: 298795,
    //               order: 8,
    //               parent: 4011,
    //               title: "Filtro de Ar-Cabine (Ar-Condicionado)",
    //               url: "/produtos/filtro-de-ar-cabine-ar-condicionado/",
    //               attr: "",
    //               target: "",
    //               classes: "",
    //               xfn: "",
    //               description: "",
    //               object_id: 298790,
    //               object: "page",
    //               object_slug: "filtro-de-ar-cabine-ar-condicionado",
    //               type: "post_type",
    //               type_label: "Página",
    //             },
    //             {
    //               id: 237825,
    //               order: 9,
    //               parent: 4011,
    //               title: "Filtro Ecológico",
    //               url: "/produtos/filtro-ecologico/",
    //               attr: "",
    //               target: "",
    //               classes: "",
    //               xfn: "",
    //               description: "",
    //               object_id: 237816,
    //               object: "page",
    //               object_slug: "filtro-ecologico",
    //               type: "post_type",
    //               type_label: "Página",
    //             },
    //             {
    //               id: 296032,
    //               order: 10,
    //               parent: 4011,
    //               title: "Filtro para Câmbio Automático",
    //               url: "/produtos/filtro-para-cambio-automatico/",
    //               attr: "",
    //               target: "",
    //               classes: "",
    //               xfn: "",
    //               description: "",
    //               object_id: 295778,
    //               object: "page",
    //               object_slug: "filtro-para-cambio-automatico",
    //               type: "post_type",
    //               type_label: "Página",
    //             },
    //             {
    //               id: 298316,
    //               order: 11,
    //               parent: 4011,
    //               title: "Filtro de Bateria",
    //               url: "/produtos/filtro-de-bateria/",
    //               attr: "",
    //               target: "",
    //               classes: "",
    //               xfn: "",
    //               description: "",
    //               object_id: 298304,
    //               object: "page",
    //               object_slug: "filtro-de-bateria",
    //               type: "post_type",
    //               type_label: "Página",
    //             },
    //             {
    //               id: 4174,
    //               order: 12,
    //               parent: 4011,
    //               title: "Velas de Ignição",
    //               url: "/produtos/velas-de-ignicao/",
    //               attr: "",
    //               target: "",
    //               classes: "",
    //               xfn: "",
    //               description: "",
    //               object_id: 4147,
    //               object: "page",
    //               object_slug: "velas-de-ignicao",
    //               type: "post_type",
    //               type_label: "Página",
    //             },
    //             {
    //               id: 4173,
    //               order: 13,
    //               parent: 4011,
    //               title: "Velas Aquecedoras",
    //               url: "/produtos/velas-aquecedoras/",
    //               attr: "",
    //               target: "",
    //               classes: "",
    //               xfn: "",
    //               description: "",
    //               object_id: 4139,
    //               object: "page",
    //               object_slug: "velas-aquecedoras",
    //               type: "post_type",
    //               type_label: "Página",
    //             },
    //             {
    //               id: 296777,
    //               order: 14,
    //               parent: 4011,
    //               title: "Filtro para Linha Moto",
    //               url: "/produtos/filtro-para-linha-moto/",
    //               attr: "",
    //               target: "",
    //               classes: "",
    //               xfn: "",
    //               description: "",
    //               object_id: 296771,
    //               object: "page",
    //               object_slug: "filtro-para-linha-moto",
    //               type: "post_type",
    //               type_label: "Página",
    //             },
    //             {
    //               id: 130061,
    //               order: 15,
    //               parent: 4011,
    //               title: "Filtro para Linha Pesada",
    //               url: "/produtos/filtro-para-linha-pesada/",
    //               attr: "",
    //               target: "",
    //               classes: "",
    //               xfn: "",
    //               description: "",
    //               object_id: 4140,
    //               object: "page",
    //               object_slug: "filtro-para-linha-pesada",
    //               type: "post_type",
    //               type_label: "Página",
    //               children: [
    //                 {
    //                   id: 130059,
    //                   order: 16,
    //                   parent: 130061,
    //                   title: "Filtro do Óleo Hidráulico",
    //                   url: "/produtos/filtro-do-oleo-hidraulico/",
    //                   attr: "",
    //                   target: "",
    //                   classes: "",
    //                   xfn: "",
    //                   description: "",
    //                   object_id: 4243,
    //                   object: "page",
    //                   object_slug: "filtro-do-oleo-hidraulico",
    //                   type: "post_type",
    //                   type_label: "Página",
    //                 },
    //                 {
    //                   id: 237824,
    //                   order: 17,
    //                   parent: 130061,
    //                   title: "Filtro de Ar – Primário e Secundário",
    //                   url: "/produtos/filtro-de-ar-primario-e-secundario/",
    //                   attr: "",
    //                   target: "",
    //                   classes: "",
    //                   xfn: "",
    //                   description: "",
    //                   object_id: 237818,
    //                   object: "page",
    //                   object_slug: "filtro-de-ar-primario-e-secundario",
    //                   type: "post_type",
    //                   type_label: "Página",
    //                 },
    //                 {
    //                   id: 130057,
    //                   order: 18,
    //                   parent: 130061,
    //                   title: "Filtro Desumidificador",
    //                   url: "/produtos/filtro-desumidificador/",
    //                   attr: "",
    //                   target: "",
    //                   classes: "",
    //                   xfn: "",
    //                   description: "",
    //                   object_id: 4245,
    //                   object: "page",
    //                   object_slug: "filtro-desumidificador",
    //                   type: "post_type",
    //                   type_label: "Página",
    //                 },
    //                 {
    //                   id: 130060,
    //                   order: 19,
    //                   parent: 130061,
    //                   title: "Filtro do Sistema de Arrefecimento",
    //                   url: "/produtos/filtro-do-sistema-de-arrefecimento/",
    //                   attr: "",
    //                   target: "",
    //                   classes: "",
    //                   xfn: "",
    //                   description: "",
    //                   object_id: 4244,
    //                   object: "page",
    //                   object_slug: "filtro-do-sistema-de-arrefecimento",
    //                   type: "post_type",
    //                   type_label: "Página",
    //                 },
    //                 {
    //                   id: 130062,
    //                   order: 20,
    //                   parent: 130061,
    //                   title: "Filtro Sedimentador",
    //                   url: "/produtos/filtro-sedimentador/",
    //                   attr: "",
    //                   target: "",
    //                   classes: "",
    //                   xfn: "",
    //                   description: "",
    //                   object_id: 4241,
    //                   object: "page",
    //                   object_slug: "filtro-sedimentador",
    //                   type: "post_type",
    //                   type_label: "Página",
    //                 },
    //                 {
    //                   id: 130058,
    //                   order: 21,
    //                   parent: 130061,
    //                   title: "Filtro do Arla32",
    //                   url: "/produtos/filtro-do-arla32/",
    //                   attr: "",
    //                   target: "",
    //                   classes: "",
    //                   xfn: "",
    //                   description: "",
    //                   object_id: 4164,
    //                   object: "page",
    //                   object_slug: "filtro-do-arla32",
    //                   type: "post_type",
    //                   type_label: "Página",
    //                 },
    //               ],
    //             },
    //           ],
    //         },
    //         {
    //           id: 2610,
    //           order: 22,
    //           parent: 0,
    //           title: "Catálogo",
    //           url: "/page/catalogo/",
    //           attr: "O que fazemos",
    //           target: "",
    //           classes: "",
    //           xfn: "",
    //           description: "",
    //           object_id: 2608,
    //           object: "page",
    //           object_slug: "catalogo",
    //           type: "post_type",
    //           type_label: "Página",
    //           children: [
    //             {
    //               id: 42827,
    //               order: 23,
    //               parent: 2610,
    //               title: "Consulta On-Line",
    //               url: "/page/consulta-on-line/",
    //               attr: "",
    //               target: "",
    //               classes: "",
    //               xfn: "",
    //               description: "",
    //               object_id: 24340,
    //               object: "page",
    //               object_slug: "consulta-on-line",
    //               type: "post_type",
    //               type_label: "Página",
    //             },
    //             {
    //               id: 51099,
    //               order: 24,
    //               parent: 2610,
    //               title: "Catálogo Off-line Ideia 2001 (arquivo instalador)",
    //               url: "https://filescloud2.ideia2001.com.br/CatExp/AHAAQ/InstalarCatalogoWegaMotors.exe",
    //               attr: "",
    //               target: "",
    //               classes: "catalogo-offline",
    //               xfn: "",
    //               description: "",
    //               object_id: 51099,
    //               object: "custom",
    //               object_slug: "arquivo-instalador-exe",
    //               type: "custom",
    //               type_label: "Link personalizado",
    //             },
    //             {
    //               id: 51069,
    //               order: 25,
    //               parent: 2610,
    //               title: "Baixe os arquivos em PDF",
    //               url: "/page/catalogo",
    //               attr: "",
    //               target: "",
    //               classes: "",
    //               xfn: "",
    //               description: "",
    //               object_id: 51069,
    //               object: "custom",
    //               object_slug: "baixe-o-catalogo-off-line",
    //               type: "custom",
    //               type_label: "Link personalizado",
    //             },
    //             {
    //               id: 4010,
    //               order: 26,
    //               parent: 2610,
    //               title: "Lançamentos",
    //               url: "/lancamentos/",
    //               attr: "",
    //               target: "",
    //               classes: "",
    //               xfn: "",
    //               description: "",
    //               object_id: 4004,
    //               object: "page",
    //               object_slug: "lancamentos",
    //               type: "post_type",
    //               type_label: "Página",
    //             },
    //           ],
    //         },
    //         {
    //           id: 295216,
    //           order: 27,
    //           parent: 0,
    //           title: "Assistência Técnica",
    //           url: "#",
    //           attr: "",
    //           target: "",
    //           classes: "",
    //           xfn: "",
    //           description: "",
    //           object_id: 295216,
    //           object: "custom",
    //           object_slug: "assistencia-tecnica",
    //           type: "custom",
    //           type_label: "Link personalizado",
    //           children: [
    //             {
    //               id: 78743,
    //               order: 28,
    //               parent: 295216,
    //               title: "Solicitação de Visita Técnica",
    //               url: "/solicitacao-de-visita-tecnica/",
    //               attr: "",
    //               target: "",
    //               classes: "",
    //               xfn: "",
    //               description: "",
    //               object_id: 78734,
    //               object: "page",
    //               object_slug: "solicitacao-de-visita-tecnica",
    //               type: "post_type",
    //               type_label: "Página",
    //             },
    //             {
    //               id: 78744,
    //               order: 29,
    //               parent: 295216,
    //               title: "Solicitação de Palestra ou Treinamento",
    //               url: "/solicitacao-de-palestra-ou-treinamento/",
    //               attr: "",
    //               target: "",
    //               classes: "",
    //               xfn: "",
    //               description: "",
    //               object_id: 78728,
    //               object: "page",
    //               object_slug: "solicitacao-de-palestra-ou-treinamento",
    //               type: "post_type",
    //               type_label: "Página",
    //             },
    //             {
    //               id: 78745,
    //               order: 30,
    //               parent: 295216,
    //               title: "Dúvidas Técnicas",
    //               url: "/duvidas-tecnicas",
    //               attr: "",
    //               target: "",
    //               classes: "",
    //               xfn: "",
    //               description: "",
    //               object_id: 78724,
    //               object: "page",
    //               object_slug: "duvidas-tecnicas",
    //               type: "post_type",
    //               type_label: "Página",
    //             },
    //             {
    //               id: 297844,
    //               order: 31,
    //               parent: 295216,
    //               title: "Formulário de Garantia Wega",
    //               url: "/formulario-de-garantia-wega/",
    //               attr: "",
    //               target: "_blank",
    //               classes: "",
    //               xfn: "",
    //               description: "",
    //               object_id: 295459,
    //               object: "page",
    //               object_slug: "formulario-de-garantia-wega",
    //               type: "post_type",
    //               type_label: "Página",
    //             },
    //           ],
    //         },
    //         {
    //           id: 2418,
    //           order: 32,
    //           parent: 0,
    //           title: "Dicas Técnicas",
    //           url: "/dica/",
    //           attr: "Dicas Técnicas",
    //           target: "",
    //           classes: "",
    //           xfn: "",
    //           description: "",
    //           object_id: 260,
    //           object: "page",
    //           object_slug: "dicas-tecnicas",
    //           type: "post_type",
    //           type_label: "Página",
    //           children: [
    //             {
    //               id: 297325,
    //               order: 33,
    //               parent: 2418,
    //               title: "Você sabia?",
    //               url: "/category/voce-sabia/",
    //               attr: "",
    //               target: "",
    //               classes: "",
    //               xfn: "",
    //               description: "",
    //               object_id: 216,
    //               object: "category",
    //               object_slug: null,
    //               type: "taxonomy",
    //               type_label: "Categoria",
    //             },
    //             {
    //               id: 297326,
    //               order: 34,
    //               parent: 2418,
    //               title: "Boletins técnicos",
    //               url: "/category/boletins-tecnicos/",
    //               attr: "",
    //               target: "",
    //               classes: "",
    //               xfn: "",
    //               description: "",
    //               object_id: 191,
    //               object: "category",
    //               object_slug: null,
    //               type: "taxonomy",
    //               type_label: "Categoria",
    //             },
    //             {
    //               id: 297327,
    //               order: 35,
    //               parent: 2418,
    //               title: "Vídeos",
    //               url: "https://www.youtube.com/wegamotorsbr",
    //               attr: "",
    //               target: "",
    //               classes: "",
    //               xfn: "",
    //               description: "",
    //               object_id: 214,
    //               object: "category",
    //               object_slug: null,
    //               type: "taxonomy",
    //               type_label: "Categoria",
    //             },
    //             {
    //               id: 297328,
    //               order: 36,
    //               parent: 2418,
    //               title: "Notícias WEGA",
    //               url: "/category/noticias-wega/",
    //               attr: "",
    //               target: "",
    //               classes: "",
    //               xfn: "",
    //               description: "",
    //               object_id: 1,
    //               object: "category",
    //               object_slug: null,
    //               type: "taxonomy",
    //               type_label: "Categoria",
    //             },
    //           ],
    //         },
    //         {
    //           id: 2417,
    //           order: 37,
    //           parent: 0,
    //           title: "Contato",
    //           url: "/contato/",
    //           attr: "Contato",
    //           target: "",
    //           classes: "",
    //           xfn: "",
    //           description: "",
    //           object_id: 271,
    //           object: "page",
    //           object_slug: "contato",
    //           type: "post_type",
    //           type_label: "Página",
    //           children: [
    //             {
    //               id: 51216,
    //               order: 38,
    //               parent: 2417,
    //               title: "Representantes",
    //               url: "/page/representantes/",
    //               attr: "",
    //               target: "",
    //               classes: "",
    //               xfn: "",
    //               description: "",
    //               object_id: 51160,
    //               object: "page",
    //               object_slug: "representantes",
    //               type: "post_type",
    //               type_label: "Página",
    //             },
    //             {
    //               id: 295131,
    //               order: 39,
    //               parent: 2417,
    //               title: "Contato Wega",
    //               url: "/contato",
    //               attr: "",
    //               target: "",
    //               classes: "",
    //               xfn: "",
    //               description: "",
    //               object_id: 295131,
    //               object: "custom",
    //               object_slug: "contato-wega",
    //               type: "custom",
    //               type_label: "Link personalizado",
    //             },
    //             {
    //               id: 298768,
    //               order: 41,
    //               parent: 2417,
    //               title: "Trabalhe Conosco",
    //               url: "/page/trabalhe-conosco/",
    //               attr: "",
    //               target: "",
    //               classes: "",
    //               xfn: "",
    //               description: "",
    //               object_id: 298763,
    //               object: "page",
    //               object_slug: "trabalhe-conosco",
    //               type: "post_type",
    //               type_label: "Página",
    //             },
    //             {
    //               id: 295222,
    //               order: 40,
    //               parent: 2417,
    //               title: "Unidades Wega",
    //               url: "/page/unidades-wega/",
    //               attr: "",
    //               target: "",
    //               classes: "",
    //               xfn: "",
    //               description: "",
    //               object_id: 295219,
    //               object: "page",
    //               object_slug: "unidades-wega",
    //               type: "post_type",
    //               type_label: "Página",
    //             },
                
    //           ],
    //         },
    //       ]
    // )

    const [ menu, setMenu ] = React.useState(null);
    
    const [ open, setOpen ] = React.useState(null)
    const [ size, setSize ] = React.useState(null)
    const [ subMenu, setSubMenu ] = React.useState(null)


    React.useEffect(() => {
        function updateSize() {
            setSize(window.innerWidth);
        }
        window.addEventListener('resize', updateSize);
        updateSize();
    })

    const LinkURL = (url) => {
        let newUrl = url.replace(defaults.wp.site, "/")
        // // newUrl = newUrl.split('/')
        // // console.log("🚀 ~ file: Menu.jsx:25 ~ LinkURL ~ newUrl", newUrl)
        // // if(newUrl.length <= 3)
        // //     newUrl = `/page/${newUrl[1]}`;
        // // else 
        //     newUrl = `${newUrl.join('/')}`;
         return newUrl;
    }
    
    React.useLayoutEffect(() => {
        var requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };
        // https://admin.wegamotors.com/wp-json/custom/menu/2
        console.log('URL -->', `${defaults.wp.site}wp-json/wp-api-menus/v2/menus/2`);
        fetch(`${defaults.wp.site}wp-json/wp-api-menus/v2/menus/2`, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log("🚀 ~ file: Menu.jsx:47 ~ React.useLayoutEffect ~ result", result)
                if(menu == null)
                    setMenu(result.items)
            })
            .catch(error => console.log('error', error));
    })

    if(menu == null) return null
         
    return(
        <nav className={`main-menu ${open && "open"}`}>
            { 
                size < 991 ?
                    size < 991 && open ?
                        <div className="headerSubmenu">
                          <div className="wg-container-logo">
                            <span className="wg-logo-item"></span>
                          </div>
                          <button className="closeButton" onClick={ () => { setOpen(false) } }>
                              <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M28.4449 24.9973L39.9866 36.539V39.5806H36.9449L25.4033 28.039L13.8616 39.5806H10.8199V36.539L22.3616 24.9973L10.8199 13.4556V10.414H13.8616L25.4033 21.9556L36.9449 10.414H39.9866V13.4556L28.4449 24.9973Z" fill="#ED1C2E"/></svg>
                          </button>
                        </div>
                    :
                        <button onClick={ () => { setOpen(true) } }>
                            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.18848 6.40729H21.9385V8.49062H3.18848V6.40729ZM3.18848 11.6156H21.9385V13.699H3.18848V11.6156ZM3.18848 16.824H21.9385V18.9073H3.18848V16.824Z" fill="#231F20"/></svg>
                        </button>
                : null
            }
            {
                size > 991 ?
                    <ul className="menu">
                        {
                            menu.map((item, key) => (
                                <li key={key}>
                                    <a href={LinkURL(item.url)}>
                                        <span>{item.title}</span>
                                        {
                                            item.children && <div className="bullet"></div>
                                        }
                                    </a>
                                    {
                                        item.children && 
                                            <ul className="submenu submenu-2-level">
                                                {
                                                    item.children.map((submenu, index) =>(
                                                        <li key={index} className="item-list">
                                                            <a href={LinkURL(submenu.url)}>{submenu.title}</a>

                                                            {
                                                                submenu.children && 
                                                                    <ul className="submenu last-submenu">
                                                                        {
                                                                            submenu.children.map((subItem, index) =>(
                                                                                <li key={index}>
                                                                                    <a href={LinkURL(subItem.url)}>{subItem.title}</a>
                                                                                </li>
                                                                            ))
                                                                        }
                                                                    </ul>
                                                            }
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                    }
                                </li>
                            ))
                        }
                    </ul>
                :
                    size < 991 && open &&
                        <ul className="menu">
                            {
                                menu.map((item, key) => (
                                    <li key={key} className={item.title == subMenu && 'isActive'}>
                                        <div className="subItemMenuMobile">
                                            <a href={LinkURL(item.url)}>{item.title}</a>
                                            {
                                                item.children && <div className="bullet" onClick={() => { item.title == subMenu ? setSubMenu(null) : setSubMenu(item.title) }}></div>
                                            }
                                        </div>
                                        {
                                            item.children && item.title == subMenu &&  
                                                <ul className="submenu">
                                                    {
                                                        item.children.map((submenu, index) =>(
                                                            <li key={index}>
                                                                <a href={submenu.url}>{submenu.title}</a>
                                                            </li>
                                                        ))
                                                      }
                                                      {/* <a href={item.children && LinkURL(item.url)}>Ver todos</a> */}
                                                </ul>
                                        }
                                    </li>
                                ))
                            }
                            
                        </ul>
            }
        </nav>
    )
}

export default Menu